// extracted by mini-css-extract-plugin
module.exports = {"container":"tabs_container__1A8Bt"};